import React, { useContext, useEffect, useRef, useState } from 'react';
import { DEFAULT_MAP } from '../../helpers/Localization';

export const MapTypeContext = React.createContext({
    contextMapTypeId: DEFAULT_MAP,
    setContextMapTypeId: () => {/* do nothing */},
});
export const useMapTypeContext = () => useContext(MapTypeContext);

export function MapTypeContextProvider(props) {
    const [contextMapTypeId, setContextMapTypeId] = useState(props.selectedMapType || DEFAULT_MAP);
    const mapTypeContextHandler = { contextMapTypeId, setContextMapTypeId };

    const addressRef = useRef();

    useEffect(() => {
        if (props.address && props.address.propertyId !== addressRef.current) {
            const selectedMapTypeId = props.selectedMapType || DEFAULT_MAP;
            setContextMapTypeId(selectedMapTypeId);
            addressRef.current = props.address.propertyId;
        }
    }, [props.address]);

    useEffect(() => {
        if (props.selectedMapType) {
            setContextMapTypeId(props.selectedMapType);
        }
    }, [props.selectedMapType]);

    return (
        <MapTypeContext.Provider value={mapTypeContextHandler}>
            {props.children}
        </MapTypeContext.Provider>
    );
}
